<template>
  <div class="card modal-card width-750">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="pdl-20px pdr-20px">
        <div class="center">
          <div class="columns is-gapless">
            <div class="column mgt-20px">
              <h1 class="title is-size-3">
                {{ $t('listeParution.popUpVente.title', {
                code: parution.nomParution,
                date: getDate(parution.dateParution),
              }) }}
              </h1>
            </div>
          </div>
        </div>
        <div class="card-content pdl-0 pdr-0">
          <div v-if="lignesCommande.length > 0">
            <div v-for="(ligne, index) in lignesCommande" :key="index">
              <div class="columns is-vcentered">
                <div class="column is-10">
                  <p class="has-text-link is-size-6 ellipsis has-text-weight-bold">
                    {{ ligne.annonceur }}</p>
                  <p class="has-text-link is-size-6 ellipsis has-text-weight-bold">
                    {{ $t('listeParution.popUpVente.produit', {
                    produit: ligne.lignePresse.libelle }) }}</p>
                  <p class="has-text-default is-size-7">{{ $t('listeParution.popUpVente.encart', {
                    encart: ligne.ligneEncart.libelle,
                    prix: ligne.ligneEncart.totalHtAvecLigneRemise }) }}</p>
                </div>
                <div class="column is-2">
                  <router-link-blank
                    :to="{ name: 'c.bodac.commandes',
                  params: {id: ligne.devisCommandeId}}"
                    :message="$t('listeParution.popUpVente.commande')"
                  />
                </div>
              </div>
              <hr class="mgt-10px mgb-10px"
                  v-if="index + 1 !== lignesCommande.length">
            </div>
          </div>
          <div v-else>
            <p class="has-text-centered has-text-weight-bold is-size-5">
              {{ $t('listeParution.popUpVente.noVente') }}
            </p>
          </div>
          <footer class="mgt-30px">
            <b-field>
              <div class="boutonAction">
                <a class="button" @click="$parent.close()">
                  {{ $t('general.button.close')}}
                </a>
              </div>
            </b-field>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';
import formatDate from '@/services/general/formatDate';

export default {
  name: 'p_infoVente',
  components: {
    routerLinkBlank,
  },
  props: {
    parution: {
      type: Object,
      required: true,
    },
    lignesCommande: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getDate(date) {
      return formatDate(date);
    },
  },
};
</script>

<style scoped>

</style>
